'use client';

import Link from '@/components/ui/Link';
import { usePathname, useSearchParams } from '@/lib/router';
import { track } from '@/lib/telemetry';
import { WalletIcon, CreditCardIcon } from '@phosphor-icons/react';

const tabs = [
  { label: 'Conta', href: '/expenses/debit', icon: WalletIcon, tabId: 'conta' },
  { label: 'Cartão de Crédito', href: '/expenses/credit', icon: CreditCardIcon, tabId: 'cartao_credito' },
] as const;

export function ExpenseTabBar() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Preserve only the month param when switching tabs
  const monthParam = searchParams.get('month');
  const sharedQuery = monthParam ? `?month=${monthParam}` : '';

  return (
    <div className="flex gap-1 rounded-xl bg-muted p-1">
      {tabs.map(({ label, href, icon: Icon, tabId }) => {
        const isActive = pathname.startsWith(href);
        return (
          <Link
            key={href}
            href={`${href}${sharedQuery}`}
            onClick={() => {
              if (!isActive) track('ui.tab_viewed', { surface: 'expenses', tab: tabId, trigger: 'switch' });
            }}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-bold transition-colors ${
              isActive
                ? 'bg-surface text-text-primary shadow-none'
                : 'text-text-secondary hover:text-text-secondary'
            }`}
          >
            <Icon size={14} />
            {label}
          </Link>
        );
      })}
    </div>
  );
}
